import axios from "axios";
import { API_BASE_URL } from "../util/constants";

export default class AuthService {
  static getCookies() {
    const cookies = {};
    document.cookie.split(";").forEach((cookie) => {
      const [key, value] = cookie.split("=");

      cookies[key.trim()] = decodeURIComponent(value);
    });

    return cookies;
  }

  static getAuthToken() {
    const cookies = this.getCookies();
    return cookies["d5-jovemdoano-session"];
  }

  static getCurrentUserData() {
    return axios.get(`${API_BASE_URL}/user/current`, {
      headers: {
        Authorization: `Bearer ${this.getAuthToken()}`,
      },
    });
  }

  static getUserVotes() {
    return axios.get(`${API_BASE_URL}/user/current/votes`, {
      headers: {
        Authorization: `Bearer ${this.getAuthToken()}`,
      },
    });
  }

  static validateToken() {
    return axios.get(`${API_BASE_URL}/validate`, {
      headers: {
        Authorization: `Bearer ${this.getAuthToken()}`,
      },
    });
  }

  static updateUserData(email, fullName, informationSharing, newsletter) {
    const data = {
      email,
      fullName,
      informationSharing,
      newsletter,
    };

    return axios.post(`${API_BASE_URL}/user`, data, {
      headers: {
        Authorization: `Bearer ${this.getAuthToken()}`,
      },
    });
  }

  static logout() {
    document.cookie = "d5-jovemdoano-session=;";
    document.cookie =
      "d5-jovemdoano-session=; domain=.draft5.gg; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
}
